<template>
  <q-page class="column no-wrap bg-white">
    <GameSummary class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import GameSummary from 'components/GameSummary.vue'
</script>
